
// ******************
//
// Ver.1.0
// Released on: Nov 15, 2023
// Phase 1.5
//
// ******************
import Vue from 'vue'
import { mapGetters } from 'vuex'
import ButtonCustom from '@/components/common_new/button-custom/index.vue'
import Title from '@/components/common_new/popup/title.vue'
export default Vue.extend({
    name: 'DeleteContractProvider',
    components: { ButtonCustom, Title },
    data() {
        return {
            titlePopup: '',
            descriptionPopup: '選択した成約事例を削除しますか？',
            formDelete: this.$form.createForm(this, {
                name: 'form_stop'
            })
        }
    },
    computed: {
        ...mapGetters('popup', ['getParamsPopup'])
    },
    methods: {
        onClosePopup() {
            this.$store.dispatch('popup/hidePopup')
        },
        async handleSubmit() {
            if (this.getParamsPopup) {
                await this.$store.dispatch(
                    'signupProvider/deleteContractInformations',
                    {
                        ids: this.getParamsPopup.id
                    }
                )
            }
        }
    }
})
